import { ButtonTab, ButtonTabs, PaginatedListProvider, laravelPaginatedListFetchConfig, useOpen } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router";
import styled from "styled-components";
import { useFilter } from "../../../../shared/filters";
import { eventService } from "../../shared/api/event/eventService";
import { EventCalendarPage } from "../EventCalendarPage";
import { EventListOverview } from "./list/EventListOverview";

const Wrapper = styled.div`
	display: grid;
	gap: 1.5rem;
	padding-bottom: 1.5rem;
	align-items: start;
`;

export interface EventScopeProps {
	showOnlyOwnEvents: boolean;
	onToggle: () => void;
}

export const EventsOverview: FC = () => {
	const { t } = useTranslation();
	const { activeFilterId } = useFilter();
	const { open: showOnlyOwnEvents, handleOpen, handleClose } = useOpen();
	const props: EventScopeProps = {
		showOnlyOwnEvents: showOnlyOwnEvents,
		onToggle: () => (showOnlyOwnEvents ? handleClose() : handleOpen()),
	};

	return (
		<Wrapper>
			<ButtonTabs color="content">
				<ButtonTab to="../overview/calendar">{t("Calendar")}</ButtonTab>
				<ButtonTab to="../overview/list">{t("List")}</ButtonTab>
			</ButtonTabs>

			<Routes>
				<Route path="calendar" element={<EventCalendarPage {...props} />} />
				<Route
					path="list"
					element={
						<PaginatedListProvider
							listFetchConfig={laravelPaginatedListFetchConfig(
								eventService.listOverviewKey
									.concat(JSON.stringify(activeFilterId || {}))
									.concat(JSON.stringify(showOnlyOwnEvents)),
								(config) => eventService.listOverview(config, activeFilterId, showOnlyOwnEvents),
							)}
						>
							<EventListOverview {...props} />
						</PaginatedListProvider>
					}
				/>
			</Routes>
		</Wrapper>
	);
};
